<div class="mc-toolbar-header">
  <mat-toolbar class="mc-flare-file-reviewer-toolbar" color="secondary">
    <mc-project-avatar [project]="(reviewFile$ | async)?.ProjectId | mcProjectAsync : true | async" [truncate]="true" size="small"></mc-project-avatar>
    <mat-divider class="mc-toolbar-divider" vertical="true"></mat-divider>
    <mc-review-package-avatar [reviewPackage]="reviewFile?.ReviewPackageId | mcReviewPackageAsync: true | async" size="small" [truncate]="true"></mc-review-package-avatar>
    <mat-divider class="mc-toolbar-divider" vertical="true"></mat-divider>
    <mc-review-file-avatar color="default" [reviewFile]="reviewFile" size="small" [truncate]="true"></mc-review-file-avatar>
    <span class="mc-fill-remaining-flex-space"></span>

    <ng-container [ngSwitch]="reviewSyncState">
      <span *ngSwitchCase="CollabSessionSyncState.SaveFailed" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Changes not Saved
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.Saved" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Saved
        <span class="mc-toolbar-spacer"></span>
        <mat-icon fontSet="project-titan" fontIcon="icon-checkmark" class="mc-centered-text-icon"></mat-icon>
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.Saving" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Saving...
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.Unsaved" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Saving...
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.Loading" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Loading...
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.Reverting" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Reverting...
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.Reverted" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Reverted
      </span>
      <span *ngSwitchCase="CollabSessionSyncState.RevertFailed" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">
        Failed to Revert Document
      </span>
    </ng-container>

    <ng-container *ngIf="reviewFileUser">
      <button *ngIf="reviewFile?.Status === ReviewFileStatus.Open && reviewFileUser.Status !== ReviewFileUserStatus.Submitted" [disabled]="submitDisabled$ | async" mat-flat-button color="primary" class="mc-flare-file-reviewer-status mc-flare-file-reviewer-submit-button mc-toolbar-item-full mc-toolbar-item-full-end" (click)="onSubmitClicked()">
        <ng-container *ngIf="submitting; else submit">Submitting</ng-container>
        <ng-template #submit>Submit</ng-template>
      </button>
      <span *ngIf="reviewFile?.Status === ReviewFileStatus.Open && reviewFileUser.Status === ReviewFileUserStatus.Submitted" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">Submitted</span>
    </ng-container>

    <span *ngIf="reviewFile?.Status === ReviewFileStatus.Closed || reviewFile?.Status === ReviewFileStatus.Accepted" class="mc-toolbar-text mc-flare-file-reviewer-toolbar-text">Read-Only</span>
  </mat-toolbar>
</div>

<mc-flare-text-editor [branchName]="reviewFile.BranchName" [commitId]="reviewFile.CommitId" editorType="collab" [featureSetVersion]="featureSetVersion" [fileId]="reviewFile.Id" [filePath]="reviewFile.Path" [fileType]="CollabFileType.Review" [licenseUser]="reviewer" [projectId]="reviewFile.ProjectId" [projectLanguage]="projectLanguage$ | async" [readonly]="false" [trackedChanges]="true" [reviewPackageId]="reviewPackageId" (contentChange)="onFileChanged($event, reviewFile.Id)" (createCollabFile)="onCreateNewReview()" (errorChange)="onErrorChanged($event)" (exceedsMaxSizeChange)="onExceedsMaxSizeChanged($event)" (exceedsMongoDBMaxSizeChange)="onExceedsMongoDBMaxSizeChanged($event)" (subEditorChange)="onSubEditorChanged($event)" (syncStateChange)="onSyncStateChanged($event)" (navToFile)="navToFile.emit($event)" [showConditions]="showConditions" (showConditionsChange)="onShowConditionsChanged($event)"></mc-flare-text-editor>